import Magnifier from './Magnifier';
import withMediaQueries from '../../hocs/withMediaQueries';

export default withMediaQueries(Magnifier);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Magnifier/index.js